export const emailResponse = 'Invalid email address'
export const inboundCheckResponse = 'inbound_policy_already_exists'